const Card = ({ number, title, cardText = "" }) => {
  return (
    <>
      <div className="col-md-4 col-lg-3 mb-2">
        <div className="card card-bg p-2">
          <div className="d-flex justify-content-between align-items-center bg-black p-2">
            <div className="user-div">
              <h4 className="text-warning lead fw-bold">{cardText}</h4>
              <div
                className={` ${
                  title === "Disqualify For This Round"
                    ? "text-dis"
                    : `${title === "Total User" ? "text-use" : "text-qua"}`
                }`}
              >
                {title}
              </div>
            </div>

            <div
              className={`card px-3 py-2 ${
                title === "Disqualify For This Round"
                  ? "disqualify"
                  : `${title === "Total User" ? "use" : "qualify"}`
              }`}
            >
              <h3>{number}</h3>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Card;
